import React, { useEffect, useRef,useState } from 'react';

import arrowLeft from "../assets/images/arrow-left.svg";
import pictoGeologie from "../assets/images/picto-geologie.svg";
import pictoMateriaux from "../assets/images/picto-materiaux.svg";
import pictoClimat from "../assets/images/picto-climat.svg";
import pictoBio from "../assets/images/picto-bioregions.svg";
import pictoArchi from "../assets/images/picto-archi.svg";
import LogoEnsam from "../assets/images/ensa-maseille-logo-main.png";

import Toggle from 'react-bootstrap-toggle';
import {paramGeologieRepresentation} from "../Map/config/layersGeologie";


export const SideBar = ({
                            hideOtherDataLayer,
                            showLayer,
                            showLegend,
                            getInfoMat,

                            brForetWmsLayerVisible,
                            brGeologieWmsLayerVisible,
                            brReliefWmsLayerVisible,
                            brTempWmsLayerVisible,
                            bvWmsLayerVisible,
                            communesWmsLayerVisible,

                            geologieLayerVisible, showLayerGeologie,geologieRepresentation,setStyleGeologieLayer,
                            carrieresLayerVisible, showLayerCarrieres,setStyleCarrieresLayer,carriereRepresentation,

                            foretLayerVisible,showLayerForet,setStyleForetLayer,foretRepresentation,
                            cultureLayerVisible, showLayerCulture, setStyleCultureLayer,cultureRepresentation,

                            climatLayerVisible,showLayerClimat,setStyleClimatLayer,climatRepresentation,climatAnnee,

                            setGeologieFilterAndRefresh,
                            showLayerBatiment,
                            batimentLayerVisible,

                            selectGeoValue, setSelectGeoValue,
                            selectCarriereValue, setSelectCarriereValue,
                            selectForetValue, setSelectForetValue,
                            selectCultureValue, setSelectCultureValue,
                            selectClimatAnneeValue, setSelectClimatAnneeValue,
                            selectClimatValue, setSelectClimatValue


}) => {

/*
    function updateGeoProps(propId){
        //var active=true;

        for(var i=0;i<geoProps.length;i++){
            if(geoProps[i].id == propId){
                if(geoProps[i].active == true){
                    active=false;
                }else{
                    active=true;
                }
            }
        }


        setGeoProps(geoProps.map(prop =>
            prop.id === propId ? { ...prop, active: true } :  { ...prop, active: false }
        ));

    }

    useEffect(() => {
        setGeologieFilterAndRefresh();
        }, [geoProps]);
*/
    const handleChangeSelectGeo = (val)  => {
        setSelectGeoValue(val);
        setStyleGeologieLayer(val);
    }
    const handleChangeSelectCarriere = (val)  => {
        setSelectCarriereValue(val);
        setStyleCarrieresLayer(val);
    }
    const handleChangeSelectForet = (val)  => {
        setSelectForetValue(val);
        setStyleForetLayer(val);

    }
    const handleChangeSelectCulture = (val)  => {
        setSelectCultureValue(val);
        setStyleCultureLayer(val);

    }
    const handleChangeSelectClimatAnnee = (val)  => {
        setSelectClimatAnneeValue(val);
        setStyleClimatLayer();

    }
    const handleChangeSelectClimat = (val)  => {
        setSelectClimatValue(val);
        setStyleClimatLayer();
    }

    return (
    <div className="sidebar-content col-12 d-flex flex-column bg-white h-100 p-3 p-xl-4 pe-0 pe-xl-0">
        <div className="col-12 pe-3 pe-xl-4">
            <div className="sidebar-content-head d-flex align-items-center justify-content-start pb-3 mb-3 mb-md-5 border-bottom border-2">
            <img className="logomain min" alt="Inventaire des ressources locales ENSAM" src={LogoEnsam} />
            <div className="d-flex flex-column justify-content-center text-start lh-xs flex-shrink-0 ps-3 min">
                <span className="fw-b fs-4">Inventaire</span>
                <span className="">des ressources locales</span>
            </div>
            <button className="toggle-btn ms-auto" id="toggleSidebar">
                <img className="" src={arrowLeft} />
            </button>
            <button className="d-none" id="reload"
                    onClick={() => showLegend()}
            >reload</button>

            <button className="d-none" id="btInfoMat"
                    onClick={() => getInfoMat()}
            >getInfoMat</button>
            <input type="hidden" value="" id="coordinatesClick" />
            </div>
        </div>
        <div className="d-flex flex-column align-items-start pb-4 min pe-3 pe-xl-4 min">
            <span className="fw-b fs-4 lh-xs">Données thématiques</span>
            <span className="text-muted text-spectral">Sélectionner un thème</span>
        </div>
        <div className="d-flex flex-column pb-lg-4 overflow-auto pe-3 pe-xl-4 minmobile">


            <a href="#!" className="acces-thematique thematique-1 d-flex align-items-center border border-2 rounded-4 px-4 py-3 mb-3">
                <img className="" src={pictoBio} alt="Biorégions"/>
                <span className="d-flex flex-column align-items-start ps-3 min">
                  <span className="fw-b fs-4 lh-xs">Biorégions</span>
                  <span className="text-muted text-spectral">Bassins versants, villes et villages</span>
              </span>
            </a>

            <div className="ss-menu-thematique thematique-1 d-flex pb-4 min ">
                <div className="col-2 h-100 dotted-pattern dotted-pattern-grey"></div>
                <div className="col-10 d-flex flex-column ps-3 min">
                    <span className="dotted-title dotted-title-grey">
                        <span className="bg-white">Voir sur la carte</span>
                    </span>
                    <div className="d-flex flex-column align-items-start pt-2">
                        <div className="d-flex flex-column align-items-start pt-2">

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("brforet")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={brForetWmsLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => hideOtherDataLayer("brforet")} className="lh-xs pe-2 fs-7" >Forêt</label>
                                </div>
                            </div>

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("brgeo")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={brGeologieWmsLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => hideOtherDataLayer("brgeo")} className="lh-xs pe-2 fs-7">Géologie</label>
                                </div>
                            </div>

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("brrelief")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={brReliefWmsLayerVisible}
                                        />
                                    </div>
                                    <label  onClick={() => hideOtherDataLayer("brrelief")} className="lh-xs pe-2 fs-7">Relief</label>
                                </div>
                            </div>

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("brtemp")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={brTempWmsLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => hideOtherDataLayer("brtemp")} className="lh-xs pe-2 fs-7">Températures</label>
                                </div>
                            </div>

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("bassinsversants")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={bvWmsLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => hideOtherDataLayer("bassinsversants")} className="lh-xs pe-2 fs-7">Bassins versants</label>
                                </div>
                            </div>

                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">

                                        <Toggle className="ios"
                                                onClick={() => hideOtherDataLayer("villesetvillages")}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                active={communesWmsLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => hideOtherDataLayer("villesetvillages")} className="lh-xs pe-2 fs-7">Villes et villages</label>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>


            <a href="#!" className="acces-thematique thematique-2 d-flex align-items-center border border-2 rounded-4 px-4 py-3 mb-3">
                <img className="" src={pictoGeologie} alt="Géologie"/>
                <span className="d-flex flex-column align-items-start ps-3 min">
                        <span className="fw-b fs-4 lh-xs">Matières géosourcées</span>
                        <span className="text-muted text-spectral">Pierre, terre</span>
                    </span>
            </a>
            <div className="ss-menu-thematique thematique-2 d-flex pb-4 min ">
                <div className="col-2 h-100 dotted-pattern dotted-pattern-grey"></div>
                <div className="col-10 d-flex flex-column ps-3 min">
                    <span className="dotted-title dotted-title-grey">
                        <span className="bg-white">Voir sur la carte</span>
                    </span>
                    <div className="d-flex flex-column align-items-start pt-2">
                        <div className="d-flex flex-column align-items-start pt-2">
                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">
                                        <Toggle className="ios"
                                                onClick={() => showLayerGeologie()}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                id="geologieLayer"
                                                active={geologieLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => showLayerGeologie()} className="lh-xs pe-2 fs-7">Données géologiques</label>
                                    <a href="#!" className="btn btn-mini btn-filtres btn-primary ms-auto elt-sup">Filtres</a>
                                </div>
                                {geologieLayerVisible &&
                                    <div className="on col-12 d-flex flex-column align-items-start border-bottom border-2 pb-3 mb-2 elt-sup">
                                        <hr className="hr-mini"/>
                                        <label htmlFor="represGeologie" className="text-muted fs-8 mb-1">Choix de la représentation</label>
                                        <select id="represGeologie" onChange={ (e) => handleChangeSelectGeo(e.target.value)} value={selectGeoValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                                            {
                                                geologieRepresentation.map((representaiton, i) => {
                                                    return (<option key={i} value={representaiton.id}>{representaiton.nom}</option>)
                                                })
                                            }
                                        </select>
                                    </div>
                                }
                            </div>
                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="div-toggle-min d-flex pe-2">
                                        <Toggle className="ios"
                                                onClick={() => showLayerCarrieres()}
                                                size="sm"
                                                on=" "
                                                off=" "
                                                width="100%"
                                                offstyle="secondary"
                                                id="carrieresLayer"
                                                active={carrieresLayerVisible}
                                        />
                                    </div>
                                    <label onClick={() => showLayerCarrieres()} className="lh-xs pe-2 fs-7">Carrières</label>
                                    <a href="#!" className="btn btn-mini btn-filtres btn-primary ms-auto elt-sup">Filtres</a>
                                </div>
                                {carrieresLayerVisible &&
                                    <div className="on col-12 d-flex flex-column align-items-start border-bottom border-2 pb-3 mb-2 elt-sup">
                                        <hr className="hr-mini"/>
                                        <label htmlFor="represCarrieres" className="text-muted fs-8 mb-1">Choix de la représentation</label>
                                        <select id="represCarrieres" onChange={ (e) => handleChangeSelectCarriere(e.target.value) } value={selectCarriereValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                                            {
                                                carriereRepresentation.map((representaiton, i) => {
                                                    return (<option key={i} value={representaiton.id}>{representaiton.nom}</option>)
                                                })
                                            }
                                        </select>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <a href="#!" className="acces-thematique thematique-3 d-flex align-items-center border border-2 rounded-4 px-4 py-3 mb-3">
                <img className="" src={pictoMateriaux} alt="Matières biosourcées"/>
                <span className="d-flex flex-column align-items-start ps-3 min">
                  <span className="fw-b fs-4 lh-xs">Matières biosourcées</span>
                  <span className="text-muted text-spectral">Bois, fibres</span>
              </span>
            </a>
            <div className="ss-menu-thematique thematique-3 d-flex pb-4 min">
                <div className="col-2 h-100 dotted-pattern dotted-pattern-grey"></div>
                <div className="col-10 d-flex flex-column ps-3 min">
                        <span className="dotted-title dotted-title-grey">
                            <span className="bg-white">Voir sur la carte</span>
                        </span>

                    <div className="d-flex flex-column align-items-start pt-2">
                        <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                            <div className="col-12 d-flex align-items-center">
                                <div className="div-toggle-min d-flex pe-2">
                                    <Toggle className="ios"
                                            onClick={() => showLayerForet()}
                                            size="sm"
                                            on=" "
                                            off=" "
                                            width="100%"
                                            offstyle="secondary"
                                            id="foretLayer"
                                            active={foretLayerVisible}
                                    />
                                </div>
                                <label onClick={() => showLayerForet()} className="lh-xs pe-2 fs-7">Forêts</label>
                                <a href="#!" className="btn btn-mini btn-filtres btn-primary ms-auto elt-sup">Filtres</a>
                            </div>
                            {foretLayerVisible &&
                                <div className="on col-12 d-flex flex-column align-items-start border-bottom border-2 pb-3 mb-2 elt-sup">
                                    <hr className="hr-mini"/>
                                    <label htmlFor="represForets" className="text-muted fs-8 mb-1">Choix de la représentation</label>
                                    <select id="represForets" onChange={ (e) => handleChangeSelectForet(e.target.value) } value={selectForetValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                                        {
                                            foretRepresentation.map((group, i) => {
                                                return <optgroup key={i} label={group.nom}>
                                                    {
                                                        group.valeurs.map((representation) => {

                                                            return (<option key={representation.id} value={representation.id}>{representation.nom}</option>)
                                                        })
                                                    }
                                                </optgroup>
                                            })
                                        }
                                    </select>
                                </div>
                            }
                        </div>

                        <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                            <div className="col-12 d-flex align-items-center">
                                <div className="div-toggle-min d-flex pe-2">
                                    <Toggle className="ios"
                                            onClick={() => showLayerCulture()}
                                            size="sm"
                                            on=" "
                                            off=" "
                                            width="100%"
                                            offstyle="secondary"
                                            id="cultureLayer"
                                            active={cultureLayerVisible}
                                    />
                                </div>
                                <label onClick={() => showLayerCulture()} className="lh-xs pe-2 fs-7">Cultures</label>
                                <a href="#!" className="btn btn-mini btn-filtres btn-primary ms-auto elt-sup">Filtres</a>
                            </div>
                            {cultureLayerVisible &&
                                <div className="on col-12 d-flex flex-column align-items-start border-bottom border-2 pb-3 mb-2 elt-sup">
                                    <hr className="hr-mini"/>
                                    <label htmlFor="represCultures" className="text-muted fs-8 mb-1">Choix de la représentation</label>
                                    <select id="represCultures" onChange={ (e) => handleChangeSelectCulture(e.target.value) } value={selectCultureValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                                        {
                                            cultureRepresentation.map((group, i) => {
                                                return <optgroup key={i} label={group.nom}>
                                                    {
                                                        group.valeurs.map((representation) => {

                                                            return (<option key={representation.id} value={representation.id}>{representation.nom}</option>)
                                                        })
                                                    }
                                                </optgroup>
                                            })
                                        }
                                    </select>
                                </div>
                            }
                        </div>


                    </div>

                </div>
            </div>

            <a href="#!" onClick={() => showLayerClimat()} className="acces-thematique thematique-4 d-flex align-items-center border border-2 rounded-4 px-4 py-3 mb-3">
                <img className="" src={pictoClimat} alt="Données climatiques"/>
                <span className="d-flex flex-column align-items-start ps-3 min">
                    <span className="fw-b fs-4 lh-xs">Climat</span>
                    <span className="text-muted text-spectral">Données et stratégies</span>
                </span>
            </a>

            <div className="ss-menu-thematique thematique-4 d-flex pb-4 min">
                <div className="col-2 h-100 dotted-pattern dotted-pattern-grey"></div>
                <div className="col-10 d-flex flex-column ps-3 min">
                        <span className="dotted-title dotted-title-grey">
                            <span className="bg-white">Année</span>
                        </span>

                        <select id="anneeClimat" defaultValue={"dc_agg_2020"} onChange={ (e) => handleChangeSelectClimatAnnee(e.target.value) } value={selectClimatAnneeValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                            {
                                climatAnnee.map((representation, i) => {
                                    return (<option key={representation.id}
                                                    value={representation.id}>{representation.nom}</option>)
                                })
                            }
                        </select>

                        <div className="d-flex flex-column align-items-start pt-2">
                            <div className="bloc-toggle d-flex flex-column col-12 pb-3">
                                <div className="col-12 d-flex align-items-center">
                                    <div className="col-12 d-flex">
                                        <div className="on col-12 d-flex flex-column align-items-start border-bottom border-2 pb-3 mb-2 elt-sup">
                                            <hr className="hr-mini"/>
                                            <label htmlFor="represClimat" className="text-muted fs-8 mb-1">Choix de la représentation</label>
                                            <select id="represClimat" onChange={ (e) => handleChangeSelectClimat(e.target.value) } value={selectClimatValue} className="form-select border border-2 rounded-pill fs-8 py-1">
                                                {
                                                    climatRepresentation.map((group, i) => {
                                                        return <optgroup key={i} label={group.nom}>
                                                            {
                                                                group.valeurs.map((representation) => {

                                                                    return (<option key={representation.id} value={representation.id}>{representation.nom}</option>)
                                                                })
                                                            }
                                                        </optgroup>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                </div>
            </div>


            <a href="#!" onClick={showLayerBatiment} className="acces-thematique thematique-5 d-flex align-items-center border border-2 rounded-4 px-4 py-3 mb-3">
                <img className="" src={pictoArchi} alt="Architecture"/>
                <span className="d-flex flex-column align-items-start ps-3 min">
                  <span className="fw-b fs-4 lh-xs">Architecture</span>
                  <span className="text-muted text-spectral">Edifices, chaînes opératoires</span>
              </span>
            </a>
        </div>
        <span className="mt-auto pt-4 text-muted fs-8 opacity-25">version 1.0</span>
    </div>
    );
}